import Button from 'components/Button'
import DateTimePicker from 'components/DateTimePicker'
import Directional from 'components/Directional'
import Label from 'components/Label'
import Quantity from 'components/Quantity'
import { TourDetailWrapper } from './styled'
import { FaHeart, FaMapMarkerAlt, FaPhone, FaMailBulk } from "react-icons/fa";
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { tourDetailActions } from 'redux/slice/tourDetailSlice'
import { tourOrderActions } from 'redux/slice/tourOrder'
import { useDispatch, useSelector } from 'react-redux'
import { tourDetailSelector, authSelector, tourOrderSelector, tourSelector, rattingCommentSelector, commentSelector } from 'redux/selector'
import Loading from 'components/Loading'
import { actionScrollToTop, getDiscount, get_day_of_time, setPrice } from 'utils'
import SlidesImage from './components/SlidesImage'
import Image from 'components/Image'
import Schedule from 'components/Schedule'
import { useState } from 'react'
import timeNow from 'helpers/timenow'
import ShowToast from 'utils/ShowToast'
import TourList from 'components/TourList'
import { tourActions } from 'redux/slice/tourSlice'
import { getAll } from 'services/infoAddressServices'
import Ratting from './components/Ratting'
import Comment from './components/Comment'
import { role } from 'common/general'

const TourDetail = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const myArray = pathname.split("/");
    const slug = myArray[myArray.length - 1];
    const dispatch = useDispatch()
    const tourDetailState = useSelector(tourDetailSelector)
    const rattingState = useSelector(rattingCommentSelector)
    const commentState = useSelector(commentSelector)
    const authState = useSelector(authSelector)
    const tourOrderState = useSelector(tourOrderSelector)
    const tourState = useSelector(tourSelector)
    const navigate = useNavigate()
    const [amountPeople, setAmountPeople] = useState(1)
    const [departureDay, setDepartureDay] = useState(timeNow)

    useEffect(() => {
        const payload = {
            slug,
            account: authState.isLoggedIn ? authState.currentUser?.user?.account_id : ""
        }

        dispatch(tourDetailActions.getTour(payload))
    }, [authState.currentUser?.user?.account_id, authState.isLoggedIn, dispatch, slug])

    const path = useMemo(() => {
        if (tourDetailState.tourData && Object.values(tourDetailState.tourData).length > 0) return [
            {
                name: tourDetailState.tourData.tour_type_name,
                path: "/tour-type/" + tourDetailState.tourData.tour_type_slug
            },
            {
                name: tourDetailState.tourData.name,
                path: "/tour/" + tourDetailState.tourData.slug
            },
        ]
        return []
    }, [tourDetailState.tourData])

    const handleAddToFavorite = () => {
        if (!authState.isLoggedIn) return navigate("/login", { state: { pathname } });
        if (authState.isLoggedIn && Object.values(tourDetailState.tourData).length > 0) {
            const data = {
                tour_id: tourDetailState.tourData.tour_id
            }
            dispatch(tourDetailActions.addFavorite({ data }))
        }

    }

    const handleRemoveToFavorite = () => {
        if (authState.isLoggedIn && Object.values(tourDetailState.tourData).length > 0) {
            dispatch(tourDetailActions.removeFavorite(tourDetailState.tourData.favorite))
        }

    }

    const handleOrderTour = () => {
        if (!authState.isLoggedIn) return navigate("/login", { state: { pathname } });
        if (Object.values(tourDetailState.tourData).length > 0 && parseInt(get_day_of_time(new Date(), new Date(departureDay))) > 3) {
            if (tourDetailState.tourData.remaining_quantity >= tourDetailState.tourData.min_person) {
                const data = {
                    tour_id: tourDetailState.tourData.tour_id,
                    departure_day: departureDay,
                    amount_of_people: amountPeople,
                    customer_email: authState.currentUser.user.email
                }
                const callBack = () => {
                    const payload = {
                        slug,
                        account: authState.isLoggedIn ? authState.currentUser?.user?.account_id : ""
                    }

                    dispatch(tourDetailActions.getTour(payload))
                }
                if (!tourOrderState.loading)
                    dispatch(tourOrderActions.createTour({ data, callBack }))
            } else {
                ShowToast("error", "Tour đã hết chỗ, vui lòng quay lại sau!")
            }
        } else {
            ShowToast("error", "Đặt tour thất bại, Bạn phải đặt thời gian khởi hành trước 3 ngày")
        }
    }

    useEffect(() => {
        if (Object.values(tourDetailState.tourData).length > 0)
            setAmountPeople(tourDetailState.tourData.min_person)
    }, [tourDetailState.tourData])

    const isEmpty = useMemo(() => {
        if (tourDetailState.tourData && Object.values(tourDetailState.tourData).length > 0) return false
        return true
    }, [tourDetailState.tourData])

    useEffect(() => {
        dispatch(tourActions.getTourRandom())
    }, [dispatch])

    useEffect(() => {
        if (!tourDetailState.loading && !tourOrderState.loading && !tourState.isFetching)
            actionScrollToTop()
    }, [tourDetailState.loading, tourOrderState.loading, tourState.isFetching])

    const [province, setProvince] = useState([])
    const provincePosition = useMemo(() => {
        let position = ""
        if (tourDetailState.tourData && Object.values(tourDetailState.tourData).length > 0 && province?.length > 0) {
            position = province?.find(item => item.code === Number(tourDetailState.tourData.province))?.name
            position += " - " + province?.find(item => item.code === Number(tourDetailState.tourData.province))?.districts.find(district => district.code === Number(tourDetailState.tourData.district))?.name
            position += " - " + province?.find(item => item.code === Number(tourDetailState.tourData.province))?.districts.find(district => district.code === Number(tourDetailState.tourData.district))?.wards.find(wards => wards.code === Number(tourDetailState.tourData.wards))?.name
        }
        return position
    }, [province, tourDetailState.tourData])

    useEffect(() => {
        const loadAddress = async () => {
            const result = await getAll()
            setProvince(result)
        }
        loadAddress()

    }, [])
    return (
        <TourDetailWrapper>
            <div className='container fluid'>
                <div className='grid pt-15'>
                    <div className='row'>
                        {
                            path.length > 0 &&
                            <div className='news-detail_pagination'>
                                <Directional paths={path} />
                            </div>
                        }
                    </div>
                    <div className='row mt-20'>
                        <div className='l-6'>
                            <div className='box_img'>
                                {
                                    !isEmpty && tourDetailState.tourData.image.length > 0 &&
                                    <SlidesImage data={tourDetailState.tourData.image} />
                                }
                                {
                                    !isEmpty && tourDetailState.tourData.image.length === 0 &&
                                    <div className='img_empty'>
                                        <Image src={tourDetailState.tourData.thumbnail} />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='l-6'>
                            {
                                !isEmpty &&
                                <div className='information bg-grey2 b-radius-4 p-15'>
                                    <h1 className='text-black s-20 medium bb-grey-1 pb-10'>{tourDetailState.tourData.name}</h1>
                                    <div className='mt-15 price'>
                                        {
                                            tourDetailState.tourData.discount > 0 &&
                                            <strike className='regular text-grey s-20 mt-10'>{setPrice(tourDetailState.tourData.price)} vnđ</strike>
                                        }
                                        <div className='bold text-red s-20'>{getDiscount(tourDetailState.tourData.price, tourDetailState.tourData.discount)} vnđ</div>
                                        {
                                            tourDetailState.tourData.discount > 0 &&
                                            <div className='medium text-white s-14 b-radius-2 mt-10 sale px-5'>Giảm:{tourDetailState.tourData.discount}%</div>
                                        }
                                    </div>
                                    <div className='mt-30 flex'>
                                        <FaMapMarkerAlt className='text-link' />
                                        <span className='text-red ml-5 medium'>{provincePosition} ({tourDetailState.tourData.specific_address})</span>
                                    </div>
                                    {
                                        authState.role === role.CUSTOMER ?
                                            tourDetailState.tourData.remaining_quantity >= tourDetailState.tourData.min_person ?
                                                tourDetailState.tourData.status === 0 ?
                                                    <>
                                                        <p className='mt-30 medium'>Còn lại: <span className='text-link bold'>{tourDetailState.tourData.remaining_quantity <= 0 ? 0 : tourDetailState.tourData.remaining_quantity}</span> Chỗ</p>
                                                        <div className='mt-20 flex'>
                                                            <Label className="mr-15">Số người:</Label>
                                                            <Quantity defaultValue={tourDetailState.tourData.min_person} minValue={tourDetailState.tourData.min_person} maxValue={tourDetailState.tourData.remaining_quantity} handleChangeInput={(e) => setAmountPeople(e)} />
                                                        </div>
                                                        <div className='mt-20 flex'>
                                                            <Label className="mr-15">Thời gian bắt đầu:</Label>
                                                            <DateTimePicker
                                                                dateInit={new Date(departureDay)}
                                                                onChangeDate={(date) => setDepartureDay(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}

                                                            />
                                                        </div>
                                                        <p className='mt-40 text-red' style={{ fontStyle: "italic" }}>(Miễn phí trẻ em dưới 12 tuổi, đi kèm 1 người lớn)</p>
                                                        <Button className={`action-default mt-30 btn-order s-18`} onClick={handleOrderTour}>Đặt tour</Button>
                                                    </> :
                                                    <Button className={`action-default mt-30 btn-order s-18 action-disable`} >Tạm dừng hoạt động</Button>
                                                :
                                                <Button className={`action-default mt-30 btn-order s-18 action-disable`} >Hết chỗ</Button>
                                            : ""

                                    }

                                    {
                                        !isEmpty && !tourDetailState.tourData.favorite && authState.role === role.CUSTOMER &&
                                        <div className='btn-add-favorite mt-30 b-grey-1 b-radius-4 bg-white flex-center clickable'
                                            onClick={handleAddToFavorite}
                                        >
                                            <FaHeart className='text-grey s-22' />
                                            <span className='ml-15 text-grey s-18'>Thêm vào tour yêu thích</span>
                                        </div>
                                    }
                                    {
                                        !isEmpty && tourDetailState.tourData.favorite && authState.role === role.CUSTOMER &&
                                        <div className='btn-add-favorite mt-30 b-grey-1 b-radius-4 bg-white flex-center clickable'
                                            onClick={handleRemoveToFavorite}
                                        >
                                            <FaHeart className='text-red s-22' />
                                            <span className='ml-15 text-red s-18'>Đã thêm vào tour yêu thích</span>
                                        </div>
                                    }
                                </div>
                            }
                            <div className='contact mt-50 b-radius-8 b-grey-1 p-15'>
                                <h2 className='text-center text-black s-22'>Liên hệ ngay</h2>
                                <div className='mt-20 contact_info'>
                                    <a href='tel:19001008' className='text-link'>
                                        <span><FaPhone className='mr-10' /></span>
                                        <span>Hotline: 19001008</span>
                                    </a>
                                    <a href="mailto:travelwithme@gmail.com" className='text-link mt-10'>
                                        <span><FaMailBulk className='mr-10' /></span>
                                        <span>Email: travelwithme@gmail.com</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-30'>
                        <div className='l-6'>
                            {
                                !isEmpty &&
                                <div>
                                    <div className='bb-grey2-1 mb-20'>
                                        <div className='text-black bold s-18 mb-20'>Mô tả:</div>
                                        <div
                                            className="regular label-l s-16 word-break description"
                                            dangerouslySetInnerHTML={{ __html: tourDetailState.tourData.content }}
                                        ></div>
                                    </div>
                                    <Ratting />
                                </div>
                            }
                        </div>
                        <div className='l-6'>
                            {
                                !isEmpty && tourDetailState.tourData.schedule.length > 0 &&
                                <div>
                                    <div className='text-black bold s-18 mb-20'>Lịch trình di chuyển:</div>
                                    <Schedule data={tourDetailState.tourData.schedule} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {
                    tourState.randomList.length > 3 &&
                    <div className="other_tour mt-50">
                        <TourList data={tourState.randomList} title="Tour khác" />
                    </div>
                }
                {/* {
                    !isEmpty &&
                    <div className='row mt-50'>
                        <div className='l-6'>
                            <Comment />
                        </div>
                    </div>
                } */}
            </div>
            {
                (tourDetailState.loading || tourOrderState.loading || tourState.isFetching || rattingState.loading || commentState.loading) &&
                <Loading />
            }
        </TourDetailWrapper>
    )
}

export default TourDetail